import React from "react";
import { Link } from "react-router";
import onClickOutside from "react-onclickoutside";
import GlobalMessage from "../components/GlobalMessage";

import logoImage from "../static/logo-payoff.svg";

import { LatestNewsFetcher } from "./News";
import { UserMenu } from "./UserMenu";
import { hasAnyRole, hasStaffRole } from "../utils/auth";
import { USER_ROLE_DEVELOPMENT_AND_ADVICE } from "../constants";

class PageHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            moreOpen: false,
            accountOpen: false
        };

        this.toggleMoreOpen = this.toggleMoreOpen.bind(this);
        this.toggleAccountOpen = this.toggleAccountOpen.bind(this);
        this.handleLogoutRequest = this.handleLogoutRequest.bind(this);
        this.timer = "";
    }

    handleClickOutside = (evt) => {
        this.setState({
            moreOpen: false,
            accountOpen: false
        });
    };

    toggleMoreOpen() {
        this.setState({
            moreOpen: !this.state.moreOpen,
            accountOpen: false
        });
    }

    toggleAccountOpen() {
        this.setState({
            moreOpen: false,
            accountOpen: !this.state.accountOpen
        });
    }

    handleLogoutRequest() {
        this.props.logoutRequest();
    }

    componentDidMount() {
        this.props.clearGlobalMessage();
    }

    render() {
        let moreOpen = this.state.moreOpen ? "toggle open" : "toggle";
        let accountOpen = this.state.accountOpen;
        let loginData = "";
        let globalMessage = "";

        const user = this.props.authentication?.user;
        const userRoles = user?.roles || [];

        if (this.props.globalmessages && this.props.globalmessages.length > 0) {
            let messages = [];
            let i = 0;
            this.props.globalmessages.forEach((msg) => {
                messages.push(<GlobalMessage key={`globalmessage-${i}`} icon={msg.icon} type={msg.type} title={msg.title} link={msg.link} />);
                i++;
            });

            globalMessage = <div className="global-message">{messages}</div>;
        }

        // Check for items if the userrole is allowed to see this
        let moreMenu = [];
        if (hasStaffRole(userRoles)) {
            moreMenu = moreMenu.concat([
                <li key="audits">
                    <Link activeClassName="active" to="/audits">
                        Controles
                    </Link>
                </li>,
                <li key="reports">
                    <Link activeClassName="active" to="/reports">
                        Rapporten
                    </Link>
                </li>,
                <li key="users">
                    <Link activeClassName="active" to="/users">
                        Gebruikers
                    </Link>
                </li>,
                <li key="authorities">
                    <Link activeClassName="active" to="/authorities">
                        Bevoegdheden
                    </Link>
                </li>,
                <li key="passes">
                    <Link activeClassName="active" to="/passes">
                        Passen
                    </Link>
                </li>
            ]);
        }
        if (hasAnyRole(userRoles, USER_ROLE_DEVELOPMENT_AND_ADVICE)) {
            moreMenu.push(
                <li key="masterdata">
                    <Link activeClassName="active" to="/masterdata">
                        Stamgegevens
                    </Link>
                </li>
            );
            moreMenu.unshift(
                <li key="competenceprofile">
                    <Link activeClassName="active" to="/competenceprofiles">
                        Competentieprofielen
                    </Link>
                </li>
            );
        }

        if (
            this.props.isLoggedIn && // ['invalid','blocked','loggedout'].includes(localStorage.loginToken)
            !window.location.href.includes("outdated")
        ) {
            loginData = (
                <>
                    <nav className="site-navigation">
                        <ul>
                            {userRoles.find((role) => ["certification", "development-and-advice", "trainer-contact"].includes(role)) ? (
                                <li>
                                    <Link activeClassName="active" to="/courses" tabIndex="-1">
                                        Cursussen
                                    </Link>
                                </li>
                            ) : (
                                false
                            )}
                            {userRoles.find((role) => ["certification", "development-and-advice", "trainer-contact"].includes(role)) ? (
                                <li>
                                    <Link activeClassName="active" to="/students" tabIndex="-1">
                                        Cursisten
                                    </Link>
                                </li>
                            ) : (
                                false
                            )}
                            {userRoles.find((role) => ["certification", "development-and-advice", "trainer-contact"].includes(role)) ? (
                                <li>
                                    <Link activeClassName="active" to="/trainers" tabIndex="-1">
                                        Opleiders
                                    </Link>
                                </li>
                            ) : (
                                false
                            )}
                            {userRoles.find((role) => ["certification", "development-and-advice", "trainer-contact"].includes(role)) ? (
                                <li>
                                    <Link activeClassName="active" to="/invoices" tabIndex="-1">
                                        Facturen
                                    </Link>
                                </li>
                            ) : (
                                false
                            )}
                            {userRoles.find((role) => ["certification", "development-and-advice", "trainer-contact"].includes(role)) ? (
                                <li>
                                    <Link activeClassName="active" to="/instructors" tabIndex="-1">
                                        Instructeurs
                                    </Link>
                                </li>
                            ) : (
                                false
                            )}
                            {userRoles.find((role) => ["certification", "development-and-advice", "trainer-contact"].includes(role)) ? (
                                <li>
                                    <Link activeClassName="active" to="/locations">
                                        Locaties
                                    </Link>
                                </li>
                            ) : (
                                false
                            )}
                            {moreMenu.length === 0 ? (
                                false
                            ) : (
                                <li onClick={this.toggleMoreOpen} className={moreOpen}>
                                    Meer
                                    <i className="fa fa-angle-down" aria-hidden="true"></i>
                                    <ul>{moreMenu}</ul>
                                </li>
                            )}
                        </ul>
                    </nav>

                    <LatestNewsFetcher />

                    <UserMenu
                        userName={user?.full_name}
                        userEmail={user?.email}
                        accountOpen={accountOpen}
                        toggleAccountOpen={this.toggleAccountOpen}
                        handleLogoutRequest={this.handleLogoutRequest}
                    />
                </>
            );
        }

        return (
            <header className="site-header">
                <a href="/" className="header-logo" tabIndex="-1">
                    <img src={logoImage} />
                </a>

                {loginData}

                {globalMessage}
            </header>
        );
    }
}

export default onClickOutside(PageHeader);
